import { Stack } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC, ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MuiSnackbar from '../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import MUIToolTip from '../../../../components/ui-component/mui-tooltip/MUIToolTip';
import { useAuthentication } from '../../../../context/AuthContext';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import { ANTRAG_VERBUNDPARTNER } from '../../../../lib/constants/componentsPath';
import {
	ANTRAG_BUTTON_NAME,
	ANTRAGS_STATUS,
	KOSTEN_ARTEN,
	KOSTEN_POSITION,
	KOSTENTRAEGER,
	MITTEL_ABRUF_IST_ABGELEHNT_TEXT,
	MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT,
	NACHWEIS_POSITION_STATUS,
	NOCH_NICHT_MOEGLICH_TEXT,
	VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT,
} from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT, getFieldNamefromDataPath, isObjectEmpty } from '../../../../utils/helper';
import { AntragButton, AntragsButtonWrapper, getMonatListe } from '../FoerderungUebersicht';

// Import Schema
import {
	getMittelabrufBankdatenFromLastMittelabrufOrAntrag,
	getMittelabrufeFromProjektJahr,
	getMittelabrufErklaerungenUndAnlagenData,
} from 'src/utils/dashboardHelper';
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPostionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
import MittelabrufSchema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from '../../../../lib/paths/nachweisposition_FULL_Paths.json';
// import VerwendungsnachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;
const MA_P = MittelabrufSchema.attributes;
// const VN_P = VerwendungsnachweisSchema.attributes;
const KP_P = KostenPostionSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const EpzFoerderDashboard: FC<{ application: any }> = ({ application }) => {
	const { authenticatedData } = useAuthentication();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [wsError, setWsError] = useState(false);

	const checkJahrCondition = true;
	const currentYear = new Date().getFullYear();

	const projektDauer = get(application, P.Allgemein_Projektdauerin_Jahren.path, 0);
	const projektJahrStart = get(application, P.Allgemein_Projektstart_Jahr.path);

	const mittelAbruf = get(application, P.Foerderantrag_Mittelabrufs.path, []);
	// const verwendungsnachweis = get(application, P.Foerderantrag_Verwendungsnachweiss.path, []);
	const abschlussbericht = get(application, P.Foerderantrag_Abschlussberichts.path, []);

	const foerderprogramm = get(application, P.Foerderprogramm.path, {});

	// const pflichtErklaerungen = get(application, P.Erklaerungen_Pflichterklaerungen.path, []);
	// const optionaleErklaerungen = get(application, P.Erklaerungen_Optionale_Erklaerungen.path, []);
	const handleCreateMittelabruf = async (projektJahr: number) => {
		// autofold/fold_next
		// const mittelabrufeImProjektJahr = mittelAbruf.filter(
		// 	(eachMA: any) =>
		// 		Number(get(eachMA, MA_P.Allgemein_Haushaltsjahr.path, 0)) === projektJahr &&
		// 		get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') !== ANTRAGS_STATUS.abgelehnt,
		// );

		// mittelabrufeImProjektJahr.sort((a: any, b: any) => {
		// 	const createdAtA = new Date(get(a, 'createdAt', 0)).getTime();
		// 	const createdAtB = new Date(get(b, 'createdAt', 0)).getTime();
		// 	return createdAtA - createdAtB;
		// });
		const mittelabrufeImProjektJahr = getMittelabrufeFromProjektJahr(mittelAbruf, projektJahr);
		const lastMittelabrufImProjektJahr = mittelabrufeImProjektJahr[mittelabrufeImProjektJahr.length - 1];
		/**
		 * erstmal auskommentiert. Umstellung auf Nachweispositionen wegen Kommentaren
		 */
		// const epzAngefallendeAusgabenVomLetztenMittelabruf =
		// 	mittelabrufeImProjektJahr.length === 0 ? null : get(lastMittelabrufImProjektJahr, MA_P.Epz_Angefallene_Ausgaben.path, null);
		// const epzAnfallendeAusgabenVomLetztenMittelabruf =
		// 	mittelabrufeImProjektJahr.length === 0 ? null : get(lastMittelabrufImProjektJahr, MA_P.Epz_Anfallende_Ausgaben.path, null);
		// const gesamt =
		// 	(Number(epzAngefallendeAusgabenVomLetztenMittelabruf ?? 0) || 0) + (Number(epzAnfallendeAusgabenVomLetztenMittelabruf ?? 0) || 0);
		const nachweispositionenVomLetztenMittelabruf = get(lastMittelabrufImProjektJahr, MA_P.Mittelabruf_Nachweispositions.path, []);
		const erklaerungenUndAnlagenData = getMittelabrufErklaerungenUndAnlagenData(foerderprogramm);

		const summeVorangegangenerMittelabrufeImHaushaltsjahr = mittelabrufeImProjektJahr.reduce(
			(acc: number, curr: any) => acc + (Number(get(curr, MA_P.Ermittlung_Des_Auszahlungsbetrages_Bereits_Ausgezahlte_Mittel.path, 0)) || 0),
			0,
		);

		const MA_Data = {
			[getFieldNamefromDataPath(MA_P.Foerderantrag.path)]: get(application, 'id'),
			[getFieldNamefromDataPath(MA_P.Mittelabrufstatus_Mittelabrufstatus.path)]: ANTRAGS_STATUS.inBearbeitung,
			[getFieldNamefromDataPath(MA_P.Allgemein_Haushaltsjahr.path)]: projektJahr,
			[getFieldNamefromDataPath(MA_P.Allgemein_Abrufdatum.path)]: new Date(),
			// Bankdaten
			...getMittelabrufBankdatenFromLastMittelabrufOrAntrag(application),
			[getFieldNamefromDataPath(MA_P.Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung.path)]: get(
				application,
				P.Bewilligung_Jahresaufteilung.path,
				[],
			).find((ele: any) => get(ele, 'Projektjahr', '') === projektJahr)?.Zuwendung,
			[getFieldNamefromDataPath(MA_P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path)]:
				summeVorangegangenerMittelabrufeImHaushaltsjahr,
			[getFieldNamefromDataPath(MA_P.Kalkulation_Block_1.path)]: [
				{
					Zelle_1: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, ''),
					Zelle_2: get(application, P.Antragstellende_Organisation_Foerderquote.path, []).find(
						(ele: any) => get(ele, 'Projektjahr') === projektJahr,
					)?.Foerderquote_403741,
				},
				...get(application, P.Verbundpartner.path, [])
					.filter((ele: any) => get(ele, ANTRAG_VERBUNDPARTNER.Name, '') !== '')
					.map((eachVP: any) => {
						return {
							Zelle_1: get(eachVP, ANTRAG_VERBUNDPARTNER.Name, ''),
							Zelle_2: get(eachVP, ANTRAG_VERBUNDPARTNER.FoerderQuoteBlock, []).find((ele: any) => get(ele, 'Projektjahr') === projektJahr)
								?.Foerderquote_403741,
						};
					}),
			],
			// Projektausgaben
			// [getFieldNamefromDataPath(MA_P.Epz_Angefallene_Ausgaben.path)]: epzAngefallendeAusgabenVomLetztenMittelabruf,
			// [getFieldNamefromDataPath(MA_P.Epz_Anfallende_Ausgaben.path)]: epzAnfallendeAusgabenVomLetztenMittelabruf,
			// [getFieldNamefromDataPath(MA_P.Epz_Gesamt.path)]: gesamt,
			// Foerderzusagen anderer Mittelgeber
			[getFieldNamefromDataPath(MA_P.Foerderungen_Anderer_Mittelgeber_EPZ_Foerderzusagen.path)]: [{ Bezeichnung_Des_Dokuments: '' }],
			...erklaerungenUndAnlagenData,
		};
		try {
			setLoading(true);
			let res = await PostRecord(APIS.Mittelabruf, { data: MA_Data });
			if (res) {
				try {
					const nachweisKombinationen = [
						{ status: NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben, kostenart: KOSTEN_ARTEN.Projektausgaben },
						{ status: NACHWEIS_POSITION_STATUS.geplant, kostenart: KOSTEN_ARTEN.Projektausgaben },
					];
					for (const { status, kostenart } of nachweisKombinationen) {
						const nachweispositionVomLetztenMittelabruf = (nachweispositionenVomLetztenMittelabruf as any[]).find(
							(eachNachweis: any) => get(eachNachweis, NP_P.Allgemein_Status.path) === status,
						);
						const kopierteAusgaben = Number(get(nachweispositionVomLetztenMittelabruf, NP_P.Allgemein_Ausgaben_Kosten.path));

						await PostRecord(APIS.Nachweisposition, {
							data: {
								Mittelabruf: get(res, 'data.id'),
								Allgemein_Status: status,
								Allgemein_Kostentraeger: KOSTENTRAEGER.Antragsteller,
								Allgemein_Unternehmen_Institution: get(authenticatedData, 'organisationId'),
								Allgemein_Kostenart: KOSTEN_POSITION.Ausgabe,
								Allgemein_Kostenart_Finanzierung: kostenart,
								Allgemein_Bezeichnung: '',
								Allgemein_Ausgaben_Kosten: kopierteAusgaben,
							},
						});
					}
				} catch (err: any) {
					setWsError(true);
					console.error('ERROR: Creating Nachweispositionen');
				} finally {
					const mittelabrufIndex =
						mittelAbruf.filter((eachMA: any) => get(eachMA, MA_P.Allgemein_Haushaltsjahr.path) === projektJahr).length + 1;

					navigate(PAGES_URLS.OnlineAntrag, {
						state: { id: get(res, 'data.id'), api: APIS.Mittelabruf, mittelabrufIndex },
					});
				}
			}
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Mittelabruf ', err);
		} finally {
			setLoading(false);
		}
	};
	const handleCreateVerwendungsNachweis = async (projektJahr: number, currentMittelAbrufId: number) => {
		const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);
		const allVerbundPartner = get(application, P.Verbundpartner.path, []);
		const VN_DATA = {
			Allgemein_Haushaltsjahr: projektJahr,
			Verwendungsnachweisstatus_Status: ANTRAGS_STATUS.inBearbeitung,
			Foerderantrag: get(application, 'id'),
			Mittelabruf: currentMittelAbrufId,
			Allgemein_Foerderquote_Antragstellerin: get(application, P.Antragstellende_Organisation_Foerderquote.path, []).find(
				(ele: any) => get(ele, 'Projektjahr') === projektJahr,
			)?.Foerderquote_403741,
			Allgemein_Foerderquote_Projektpartner: [
				...allVerbundPartner.map((eachVPartner: any) => {
					return {
						Partner: get(eachVPartner, 'Verbundpartner.id'),
						Partner_Quote: get(eachVPartner, ANTRAG_VERBUNDPARTNER.FoerderQuoteBlock, []).find(
							(ele: any) => get(ele, 'Projektjahr') === projektJahr,
						)?.Foerderquote_403741,
					};
				}),
			],
		};

		try {
			setLoading(true);
			const vnRes = await PostRecord(APIS.Verwendungsnachweis, { data: VN_DATA });
			if (vnRes) {
				for (let i = 0; i < allKostenPosition.length; i++) {
					const eachKP = allKostenPosition[i];
					const NW_DATA = {
						Allgemein_Nr: i + 1,
						Allgemein_Kostentraeger: get(eachKP, KP_P.Allgemein_Kostentraeger.path),
						Allgemein_Unternehmen_Institution: get(eachKP, `${KP_P.Unternehmen.path}.id`),
						Verwendungsnachweis: get(vnRes, 'data.id'),
						Allgemein_Kostenposition: get(eachKP, 'id'),
						Allgemein_Kostenart: get(eachKP, KP_P.Allgemein_Kostenposition.path),
						Allgemein_Bezeichnung: get(eachKP, KP_P.Allgemein_Bezeichnung.path),
						Kostennachweise_Nachweise: [{ Kommentar: '' }],
						Stundennachweis_Geleistete_Stunden: getMonatListe(eachKP),
					};
					await PostRecord(APIS.Nachweisposition, { data: NW_DATA });
				}
			}
		} catch (err: any) {
			console.error('ERROR: Creating Verwendungsnachweis ', err);
		} finally {
			setLoading(false);
			navigate(PAGES_URLS.OnlineAntrag, { state: { id: currentMittelAbrufId, api: APIS.Mittelabruf } });
		}
	};
	const handleCreateAbschlussbericht = async () => {
		// autofold/fold_next
		let abBerichtData = {
			Foerderantrag: get(application, 'id'),
			Abschlussberichtstatus_Abschlussberichtsstatus: ANTRAGS_STATUS.inBearbeitung,
			Antragsteller: get(application, `${P.Antragstellende_Organisation.path}.id`),
		};

		try {
			setLoading(true);
			let res = await PostRecord(APIS.Abschlussbericht, { data: abBerichtData });
			if (res) navigate(PAGES_URLS.OnlineAntrag, { state: { id: get(res, 'data.id'), api: APIS.Abschlussbericht } });
		} catch (err: any) {
			console.error('ERROR: Creating Abschlussbericht ', err);
		} finally {
			setLoading(false);
		}
	};

	const RenderMittelabrufButtons: FC<{}> = () => {
		// autofold/fold_next
		const buttons: ReactElement[] = [];

		// Group Mittelabruf by Haushaltsjahr (project year)
		const groupedMittelabrufNachProjektJahr = mittelAbruf.reduce((acc: any, item: any) => {
			const year = item.attributes.Allgemein_Haushaltsjahr;
			if (!acc[year]) {
				acc[year] = [];
			}
			acc[year].push(item);
			return acc;
		}, {});

		// Loop through each year of the project duration
		for (let i = 0; i < projektDauer; i++) {
			const currentProjektJahr = projektJahrStart + i; // Determine current year

			// Check if there's any Mittelabruf for the current year
			const mittelabrufForYear = groupedMittelabrufNachProjektJahr[currentProjektJahr];
			const zuwendungImProjektJahr = Number(
				get(application, P.Bewilligung_Jahresaufteilung.path, []).find((ele: any) => get(ele, 'Projektjahr', '') === currentProjektJahr)
					?.Zuwendung ?? 0,
			);
			const summeVorangegangenerMittelabrufeImHaushaltsjahr = (mittelabrufForYear || []).reduce(
				(acc: number, curr: any) => acc + (Number(get(curr, MA_P.Ermittlung_Des_Auszahlungsbetrages_Bereits_Ausgezahlte_Mittel.path, 0)) || 0),
				0,
			);
			const shouldShowCreateMittelabrufButton = zuwendungImProjektJahr - summeVorangegangenerMittelabrufeImHaushaltsjahr > 0;

			// Determine whether the button to create Mittelabruf for this year should be enabled
			const isYearValidForCreation = checkJahrCondition ? currentProjektJahr === currentYear : true;

			// If there are Mittelabruf(s) for the year, show them
			if (mittelabrufForYear && mittelabrufForYear.length > 0) {
				// Checking if the last mittelabruf has the status "freigegeben"
				const isLastMittelFrei =
					(
						get(mittelabrufForYear[mittelabrufForYear.length - 1], MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') ===
							ANTRAGS_STATUS.freigegeben ||
						get(mittelabrufForYear[mittelabrufForYear.length - 1], MA_P.Mittelabrufstatus_Mittelabrufstatus.path, '') ===
							ANTRAGS_STATUS.abgelehnt
					) ?
						true
					:	false;
				let isMAErstellenButtonDisabled: boolean = false;
				if (isLastMittelFrei) {
					if (isMAErstellenButtonDisabled) {
						// if last mittelabruf is "freigegeben" but the current year is not valid then no MA can be created
						isMAErstellenButtonDisabled = true;
					} else {
						isMAErstellenButtonDisabled = false;
					}
				} else {
					// Disable the create button, if last MA for this year does not has the status "freigegeben"
					isMAErstellenButtonDisabled = true;
				}
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
						{mittelabrufForYear.map((eachMA: any, index: number) => {
							return (
								<AntragButton
									key={`mittelabruf-${currentProjektJahr}-${index}`}
									name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
									description={enumT(get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path))}
									onClick={() =>
										navigate(PAGES_URLS.OnlineAntrag, {
											state: {
												id: get(eachMA, 'id'),
												api: APIS.Mittelabruf,
												mittelabrufIndex: index + 1,
											},
										})
									}
								/>
							);
						})}

						{shouldShowCreateMittelabrufButton && (
							<MUIToolTip
								title='Sie können neuen Mittelabruf für das Jahr erstellen, sobald die vorherige Mittelabruf freigegeben ist'
								showTootip={isMAErstellenButtonDisabled}
							>
								<AntragButton
									name='Mittelabruf erstellen'
									description=''
									onClick={() => handleCreateMittelabruf(currentProjektJahr)}
									variant={'contained'}
									disabled={isMAErstellenButtonDisabled}
								/>
							</MUIToolTip>
						)}
					</AntragsButtonWrapper>,
				);
			} else {
				// If there are no Mittelabruf for the year, show the button to create a new one for a new year
				if (get(application, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.inFoerderung && shouldShowCreateMittelabrufButton) {
					buttons.push(
						<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
							<AntragButton
								name='Mittelabruf erstellen'
								description=''
								onClick={() => handleCreateMittelabruf(currentProjektJahr)}
								variant={'contained'}
								disabled={!isYearValidForCreation} // Disable if the year is not valid
							/>
						</AntragsButtonWrapper>,
					);
				} else {
					buttons.push(
						<AntragsButtonWrapper key={currentProjektJahr} title={'Mittelabruf für ' + currentProjektJahr}>
							<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} disabled={true} />
						</AntragsButtonWrapper>,
					);
				}
			}
		}

		return <>{buttons}</>;
	};
	const RenderVerwendungsnachweisButtons: FC<{}> = () => {
		const buttons: ReactElement[] = [];

		// Group Mittelabruf by Haushaltsjahr (project year)
		const groupedMittelabrufNachProjektJahr = mittelAbruf.reduce((acc: any, item: any) => {
			const year = item.attributes.Allgemein_Haushaltsjahr;
			if (!acc[year]) {
				acc[year] = [];
			}
			acc[year].push(item);
			return acc;
		}, {});
		// Group Mittelabruf by Haushaltsjahr (project year)
		// const groupedVerwendungsnachweisNachProjektJahr = verwendungsnachweis.reduce((acc: any, item: any) => {
		// 	const year = get(item, VN_P.Allgemein_Haushaltsjahr.path);
		// 	if (!acc[year]) {
		// 		acc[year] = [];
		// 	}
		// 	acc[year].push(item);
		// 	return acc;
		// }, {});

		// Loop through each year of the project duration
		for (let i = 0; i < projektDauer; i++) {
			const currentProjektJahr = projektJahrStart + i; // Determine current year

			// Check if there's any Mittelabruf for the current year
			// const verwendungsnachweisForYear = groupedVerwendungsnachweisNachProjektJahr[currentProjektJahr];
			const mittelabrufForYear = groupedMittelabrufNachProjektJahr[currentProjektJahr];

			// Determine whether the button to create Verwendungsnachweis for this year shoul be enabled
			// const isYearValidForCreation = checkJahrCondition ? currentProjektJahr === currentYear : true;

			// If there are Mittelabruf(s) for the year, show them
			if (mittelabrufForYear && mittelabrufForYear.length > 0) {
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Verwendungsnachweis für ' + currentProjektJahr}>
						{mittelabrufForYear.map((eachMA: any, index: number) => {
							if (!isObjectEmpty(get(eachMA, MA_P.Mittelabruf_Verwendungsnachweiss.path, {}))) {
								// Wenn VN in MA gibt, wird diese button angezeigt, welche zu Antrag navigiert
								return (
									<AntragButton
										key={`vn-${currentProjektJahr}-${index}`}
										name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
										description={enumT(
											get(eachMA, MA_P.Mittelabruf_Verwendungsnachweiss.schema.attributes.Verwendungsnachweisstatus_Status.path),
										)}
										onClick={() =>
											navigate(PAGES_URLS.OnlineAntrag, {
												state: {
													id: get(eachMA, `id`),
													api: APIS.Mittelabruf,
												},
											})
										}
									/>
								);
							} else {
								// wenn noch kein VN zu MA gibt. Werden die VNs button abhängig vom MA-Status angezeigt
								if (get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path) === ANTRAGS_STATUS.abgelehnt) {
									// Kein VN ist erförderlich, da MA abgelehnt wurde
									return (
										<MUIToolTip title={MITTEL_ABRUF_IST_ABGELEHNT_TEXT}>
											<AntragButton
												key={`vn-${currentProjektJahr}-${index}`}
												name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
												description={'Nicht möglich'}
												onClick={() => {}}
												disabled={true}
											/>
										</MUIToolTip>
									);
								} else if (get(eachMA, MA_P.Mittelabrufstatus_Mittelabrufstatus.path) !== ANTRAGS_STATUS.inBearbeitung) {
									// VN-Erstellung im Portal für EPZ noch nicht umgesetzt -> Button vorerst deaktiviert.
									// handleCreateVerwendungsNachweis bleibt erhalten und wird bei Umsetzung des EPZ-VN wieder aktiviert.
									return (
										<MUIToolTip title={VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT} showTootip={true}>
											<AntragButton
												key={`vn-erstellen-${currentProjektJahr}-${index}`}
												name='Verwendungsnachweis erstellen'
												description=''
												// Handler verdrahtet, damit er beim Re-Enable des EPZ-VN direkt genutzt werden kann; disabled Buttons feuern nicht.
												onClick={() => handleCreateVerwendungsNachweis(currentProjektJahr, get(eachMA, 'id'))}
												variant={'contained'}
												disabled={true}
											/>
										</MUIToolTip>
									);
								} else {
									// VN erstellen noch nicht möglich, weil MA noch in Bearbeitung ist.
									return (
										<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
											<AntragButton
												key={`vn-${currentProjektJahr}-${index}`}
												name={`Projektjahr: ${get(eachMA, MA_P.Allgemein_Haushaltsjahr.path)} #${index + 1}`}
												description={'erstellen'}
												onClick={() => {}}
												disabled={true}
											/>
										</MUIToolTip>
									);
								}
							}
						})}
						{/* Diese ist ein Platzhalter Button, der immer disabled ist.  */}
						<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
							<AntragButton name='Verwendungsnachweis erstellen' description='' onClick={() => {}} disabled={true} variant={'contained'} />
						</MUIToolTip>
					</AntragsButtonWrapper>,
				);
			} else {
				// Platzhalter Button für jedes Jahr, der immer disabled ist.
				buttons.push(
					<AntragsButtonWrapper key={currentProjektJahr} title={'Verwendungsnachweis für ' + currentProjektJahr}>
						<MUIToolTip title={MITTEL_ABRUF_ZUERST_ERSTELLEN_TEXT}>
							<AntragButton name='Verwendungsnachweis erstellens' description='' onClick={() => {}} disabled={true} variant={'contained'} />
						</MUIToolTip>
					</AntragsButtonWrapper>,
				);
			}
		}

		return <>{buttons}</>;
	};
	const RenderAbschlussberichtButton: FC<{}> = () => {
		// autofold/fold_next
		if (isArray(abschlussbericht) && abschlussbericht.length > 0) {
			return (
				<AntragsButtonWrapper title='Abschlussbericht:'>
					{abschlussbericht.map((eachAbschlussbericht: any, i: number) => {
						return (
							<AntragButton
								key={i}
								name='Abschlussbericht'
								description='Ansehen'
								onClick={() =>
									navigate(`${PAGES_URLS.OnlineAntrag}`, {
										state: { id: get(eachAbschlussbericht, 'id'), api: APIS.Abschlussbericht },
									})
								}
							/>
						);
					})}
				</AntragsButtonWrapper>
			);
		} else {
			if (get(application, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.ProjektBeendet) {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton
							name='Abschlussbericht'
							description='Abschlussbericht erstellen'
							onClick={handleCreateAbschlussbericht}
							variant='text'
						/>
					</AntragsButtonWrapper>
				);
			} else {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} variant='text' disabled={true} />
					</AntragsButtonWrapper>
				);
			}
		}
	};

	return (
		<>
			<LoadingBackdrop open={loading} />

			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
			<AntragsButtonWrapper title='Antrag:'>
				<AntragButton
					name={get(application, P.Allgemein_Projekttitel.path) ? get(application, P.Allgemein_Projekttitel.path) : ANTRAG_BUTTON_NAME}
					description={enumT(get(application, P.Antragstatus_Antragstatus.path))}
					onClick={() =>
						navigate(PAGES_URLS.OnlineAntrag, {
							state: {
								id: get(application, 'id'),
								api: APIS.Antrag,
								antragsformular: get(application, P.Allgemein_Antragsformular.path),
							},
						})
					}
				/>
			</AntragsButtonWrapper>

			<Stack direction='row' spacing={2} justifyContent={'space-between'}>
				<span>
					<RenderMittelabrufButtons />
				</span>
				<span>
					<RenderVerwendungsnachweisButtons />
				</span>
			</Stack>
			<RenderAbschlussberichtButton />
		</>
	);
};

export default EpzFoerderDashboard;
